import Cookies from 'js-cookie'
var DOMParser = require('xmldom').DOMParser

// 派遣區判斷
function parseKmlToPointsArray(strkml) {
  if (strkml === null) return null
  let parser = new DOMParser()
  let xmlDoc = parser.parseFromString(strkml, 'text/xml')
  if (xmlDoc.getElementsByTagName('coordinates')[0] === undefined) {
    return null
  }
  if (
    xmlDoc.getElementsByTagName('coordinates')[0].childNodes[0] === undefined
  ) {
    // console.log('======XXXX====')
    // console.log('strkml', strkml)
    return null
  }
  let gpsArrageArray = []
  let geoArray = []
  let pointArray = []
  let count = 0
  try {
    let str = xmlDoc
      .getElementsByTagName('coordinates')[0]
      .childNodes[0].nodeValue.trim()
      .replace(/\↵/g, '')
      .replace(/\s+/g, '')
      .split(',')
    for (let i = 0; i < str.length; i++) {
      if (parseFloat(str[i]) !== 0) {
        gpsArrageArray.push(parseFloat(str[i]))
      }
    }
    for (let i = 0; i < gpsArrageArray.length; i++) {
      if (count !== 1) {
        count += 1
        pointArray.push(gpsArrageArray[i])
      } else {
        pointArray.push(gpsArrageArray[i])
        geoArray.push(pointArray)
        count = 0
        pointArray = []
      }
    }
  } catch (err) {
    console.log(err)
  }
  return geoArray
}
// 射線法來判斷點是否在範圍內
function rayCasting(point, poly) {
  var px = point[0], // 經度
    py = point[1], // 緯度
    flag = false
  // [[],[],[]]
  for (let i = 0, l = poly.length, j = l - 1; i < l; j = i, i++) {
    var sx = poly[i][0],
      sy = poly[i][1],
      tx = poly[j][0],
      ty = poly[j][1]
    // 點與多邊形頂點重合
    if ((sx === px && sy === py) || (tx === px && ty === py)) {
      return 'on'
    }

    // 判斷線段兩端點是否在射線兩側
    if ((sy < py && ty >= py) || (sy >= py && ty < py)) {
      // 線段上與射線Y座標相同的點X座標
      var x = sx + ((py - sy) * (tx - sx)) / (ty - sy)

      // 點在多邊形上
      if (x === px) {
        return 'on'
      }

      // 射線穿過多邊形的邊界
      if (x > px) {
        flag = !flag
      }
    }
  }
  // 設限穿過多邊形邊界的次數為奇數時點在多邊形內
  return flag ? 'in' : 'out'
}
export default {
  parseKmlToPointsArray,
  rayCasting,
}



// WEBPACK FOOTER //
// ./src/assets/js/tool/checkPointInKml.js